/**
 * Shows a popup message to the user for a few seconds, then auto-hides.
 * Usage: sidekickPopupMessage.show('Your message here');
 */
const sidekickPopupMessage = {
    show(message, duration = 5000, type = '') {
        let container = document.querySelector('.notification-message');
        if (!container) { return; }
        container.innerHTML = '';
        container.style.display = 'flex';
        container.classList.add('sk-popup-message');
        if (type === 'error') { container.classList.add('sk-popup-message--error'); }
        if (type === 'success') { container.classList.add('sk-popup-message--success'); }

        // Add icon
        let icon = document.createElement('span');
        icon.className = 'sk-popup-message__icon';
        icon.innerHTML = type === 'error' ? '&#9888;' : (type === 'success' ? '&#10003;' : '&#9432;');
        container.appendChild(icon);

        // Add message
        let msgSpan = document.createElement('span');
        msgSpan.textContent = message;
        container.appendChild(msgSpan);

        // Add close button
        let closeBtn = document.createElement('button');
        closeBtn.className = 'sk-popup-message__close';
        closeBtn.innerHTML = '&times;';
        closeBtn.onclick = function() {
            container.style.display = 'none';
        };
        container.appendChild(closeBtn);

        setTimeout(() => {
            container.style.display = 'none';
        }, duration);
    }
};

export default sidekickPopupMessage;
